import React, { useEffect, useState } from 'react';

import styles from './DogCardADLatest.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import SingleValueCard from '../../../../Statistics/Cards/SingleValueCard/SingleValueCard';

function DogCardADLatest(props: DogCardADLatestProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();

    function getData() {
        if (auth.selectedBreed == undefined || !props.dogId) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/health/ad/latest",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined && props.dogId) {
            getData();
        }
    }, [auth.selectedBreed, props.dogId]);

    return (
        <div className={styles.statisticshealth}>
            <SingleValueCard
                title={t("dog.statistics.ad.title")}
                data={data}
            ></SingleValueCard>
        </div>
    );
}

class DogCardADLatestProps {
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardADLatest;
